const routes = [
  {
    path: '/clients',
    name: 'clients',
    component: () => import(/* webpackChunkName: "CrmPage" */ './views/CrmPage.vue'),
    props: (route) => ({
      query: route.query,
    }),
    meta: { i18n: 'client-pov', pageNameEn: 'Clients' },
  },
];

export default routes;
